import { isNil, find, map } from 'lodash'

export default {
    findChild: (data, currentDataId) => {
        return !isNil(
            find(data, cs => {
                return cs.parent_wam_custom_segment_id === currentDataId
            })
        )
    },

    getParentJsonKeyName: parentJsonKey => {
        return isNil(parentJsonKey) ? parentJsonKey : 'custom_segment_' + parentJsonKey
    },

    getSmartSegmentIds: smartSegments => {
        if (isNil(smartSegments)) return []
        return map(smartSegments, smartSegmemt => {
            return smartSegmemt.id
        })
    }
}
